import styles from "./Reviews.module.css";

const reviews = [
  {
    name: "virtus81",
    review: `Everything perfect, shipped fast and working properly!`,
    date: "Mar 2023",
  },
  {
    name: "virtus81",
    review: `The best work to date, really impressive, I have no words to describe the quality of this work, it is absolutely perfect. We love working with this seller`,
    date: "Mar 2023",
  },
  {
    name: "virtus81",
    review: `A magnificent job, fast, well done, met all the details and requirements, certainly our trusted developer`,
    date: "Jan 2023",
  },
  {
    name: "ahm3not3p",
    review: `A fruitful and professional collaboration on a prototype. Hiring immediately to take it to a full game.`,
    date: "Dec 2022",
  },
  {
    name: "virtus81",
    review: `Great work, We need a complex file for our project, everything was fixed and delivered quickly. A highly recommended service`,
    date: "Dec 2022",
  },
  {
    name: "virtus81",
    review: `Great job, really good. He helped us throughout the process, recommended the best configurations and did an outstanding job. Definitely highly recommended`,
    date: "Nov 2022",
  },
  {
    name: "virtus81",
    review: `He solved my doubts and guided me through the process. Great job, highly recommended`,
    date: "Oct 2022",
  },
  {
    name: "julianvidal763",
    review: `One of the best experiences I've had on Fiverr so far! A great guy with great skills!`,
    date: "Aug 2022",
  },
  {
    name: "zettstream",
    review: `Excellent service tailored to customer`,
    date: "Jul 2022",
  },
  {
    name: "starkepilot",
    review: `Locus Amoenus is a great seller to work with. They have excellent communication and went above and beyond to not only accomplish the task I needed help with, but also provide great documentation explaining the code and how to implement it in my project. They helped me fix some bugs I was struggling with and improved my player controller and how it interacts with a few other systems in my game. I highly recommend working with them. I know I will be next time I need help in my Unity project.`,
    date: "Jul 2022",
  },
  {
    name: "virtus81",
    review: `Trusted seller, good job and fast delivery!`,
    date: "Jun 2022",
  },
  {
    name: "virtus81",
    review: `Another awesome job! Without a doubt, my trusted developer. Fast, good and detailed work`,
    date: "Jun 2022",
  },
  {
    name: "fulicny",
    review: `Phenomenal work.`,
    date: "Jun 2022",
  },
  {
    name: "virtus81",
    review: `All correct, fast delivery, well detailed and explained the operation! We are very happy with the service`,
    date: "Jun 2022",
  },
  {
    name: "virtus81",
    review: `Perfect work, fast delivery, detailed work, with periodic updates. The work was just what we wanted, taking care of the details, explaining and helping us in the process, answered the questions and corrected things we needed. Without a doubt possibly one of the best Fiverr sellers, Amazing!`,
    date: "Jun 2022",
  },
  {
    name: "ilovegameslol",
    review: `Great experience👍`,
    date: "May 2022",
  },
  {
    name: "techhumanmktg",
    review: `Good job fast. I enjoyed working with them and will again in the future.`,
    date: "May 2022",
  },
  {
    name: "overcast_games",
    review: `When I searched for Unity game development, I didn’t know what to expect. Locus Amoenus did an amazing job! I’m so glad I found them and I recommend this team to anyone who is in need of game development`,
    date: "May 2022",
  },
  {
    name: "mariasaras",
    review: `This team is fantastic. They did an amazing job, made sure they understood my vision and made it even better than what I imagined. They are fast, efficient and deliver high quality projects. Thank you so much!`,
    date: "May 2022",
  },
];

const groupedReviews = reviews.reduce((groups, currentReview) => {
  const existingGroup = groups.find((group) => group.name === currentReview.name);

  if (existingGroup) {
    existingGroup.reviews.push(currentReview);
    return groups;
  }

  groups.push({
    name: currentReview.name,
    reviews: [currentReview],
  });

  return groups;
}, []);

function ReviewGroup({ name, reviews: clientReviews }) {
  const latestReview = clientReviews[0];
  const earliestReview = clientReviews[clientReviews.length - 1];
  const isRepeatClient = clientReviews.length > 1;

  return (
    <div className={styles.reviewGroup}>
      <div className={styles.header}>
        <div>
          <div className={styles.name}>{name}</div>
          <div className={styles.meta}>
            {isRepeatClient
              ? `${clientReviews.length} separate reviews from a repeat client`
              : `1 review`}
            {latestReview.date !== earliestReview.date &&
              ` · ${earliestReview.date} to ${latestReview.date}`}
          </div>
        </div>
        <div className={styles.stars}>⭐⭐⭐⭐⭐</div>
      </div>

      <div className={styles.reviewList}>
        {clientReviews.map((clientReview, index) => (
          <div key={`${name}-${index}`} className={styles.reviewEntry}>
            <div className={styles.reviewQuote}>{clientReview.review}</div>
            <div className={styles.date}>{clientReview.date}</div>
          </div>
        ))}
      </div>
    </div>
  );
}

function Reviews() {
  return (
    <div className={styles.reviews}>
      <p className={styles.intro}>
        After graduating from Kingston University, I moved to Italy with a
        colleague, where we started our own freelance development business. We
        worked on over 20 client projects and received a 5-star rating for 100%
        of our work. Some clients came back multiple times for follow-on work,
        so the reviews below are grouped by client rather than shown as a flat
        feed.
      </p>

      {groupedReviews.map((reviewGroup, i) => (
        <ReviewGroup
          key={`${reviewGroup.name}-${i}`}
          name={reviewGroup.name}
          reviews={reviewGroup.reviews}
        />
      ))}
    </div>
  );
}

export default Reviews;
